import { UPDATE_STUDENT_LIST, UPDATE_CLASS_LIST, UPDATE_GROUP_LIST, UPDATE_SELECTED_CLASS_GROUP, CHECKBOX_SELECT,
    UPDATE_PASSWORD, UNASSIGN_STUDENTS, REDO_UPDATE_GROUP_LIST,
    UPDATE_QUERY_PARAMS, CLICK_ACTION_TYPE } from './whole-class-actions';
import { FOOTER_BUTTON_CLICK, FOOTER_BUTTONS_SETUP } from '../../components/page-footer/page-footer-actions';
import { EXECUTE_CONFIRM_COMMAND } from '../../containers/confirmation-modal/confirmation-modal-actions';

const initialState = {
    classList: undefined,
    groupList: [],
    studentList: [],
    studentSum: {},
    selectedClassId: undefined,
    selectedGroupId: undefined,
    queryParams: {}
};

export default function (state = initialState, action) {
    if (!action) return state;
    const payload = action.payload;
    switch (action.type) {
    /** @todo - add real actions consumed by this reducer */
    case UPDATE_STUDENT_LIST:
        return {
            ...state,
            studentList: payload.studentList,
            studentSum: payload.studentSum,
            redoUpdateGroup: payload.redoUpdateGroup,
            needFootBtnSetup: true
        };
    case UPDATE_GROUP_LIST:
        return {
            ...state,
            groupList: payload.groupList
        };
    case UPDATE_CLASS_LIST:
        return {
            ...state,
            classList: payload.classList
        };
    // currently the response of getTeacherClassMgmtUnassignStudent is designed to be not required to
    // have information of current "selected GroupId" neither provide the selected group students, need
    // front end to readjustment for work out this.
    case REDO_UPDATE_GROUP_LIST:
        return {
            ...state,
            redoUpdateGroup: payload.redoUpdateGroup
        };
    case UPDATE_SELECTED_CLASS_GROUP:
    {
        const newState = {
            ...state,
            selectedClassId: payload.selectedClassId,
            selectedGroupId: payload.selectedGroupId
        };

        return newState;
    }
    case CHECKBOX_SELECT:
        return {
            ...state,
            needFootBtnSetup: true
        };
    case UPDATE_PASSWORD:
        return {
            ...state,
            passwordRevertBack: payload.passwordRevertBack
        };
    case FOOTER_BUTTON_CLICK:
        return {
            ...state,
            clickActionType: payload.action
        };
    case FOOTER_BUTTONS_SETUP:
        return {
            ...state,
            needFootBtnSetup: false
        };
    case EXECUTE_CONFIRM_COMMAND:
        return {
            ...state,
            clickActionType: undefined,
            unassignCommandInfo: payload.commandInfo
        };
    case UNASSIGN_STUDENTS:
        return {
            ...state,
            clickActionType: undefined,
            unassignCommandInfo: undefined
        };
    case UPDATE_QUERY_PARAMS: {
        const query = state.queryParams;
        return {
            ...state,
            queryParams: {
                ...query,
                ...payload
            }
        };
    }
    case CLICK_ACTION_TYPE:
        return {
            ...state,
            clickActionType: undefined
        };

    default:
        return { ...state,
            redoUpdateGroup: undefined,
            clickActionType: undefined,
            unassignCommandInfo: undefined,
            needFootBtnSetup: undefined
        };
    }
}



// WEBPACK FOOTER //
// ./containers/whole-class/whole-class-reducer.js